import React from "react";

import { Box, Pagination, SelectField, Typography } from "..";
import useBreakpoints from "../hooks/useBreakpoints";
import { PaginatorProps } from "./Paginator.types";
import { useStyles } from "./Paginator.styles";

function Paginator(props: PaginatorProps) {
  const {
    itemsPerPageOptions,
    page,
    itemsPerPage,
    totalCount,
    itemsPerPageLabel,
    onPageChange,
    onItemsPerPageChange,
    labelDisplayedRows,
    hasMore,
    title,
    ...other
  } = props;

  const classes = useStyles();

  const { mdUp } = useBreakpoints();

  const handlePageChange = (event: any, newPage: number) => {
    onPageChange(newPage - 1);
  };

  const text = React.useMemo(() => {
    if (
      totalCount === undefined ||
      itemsPerPage === undefined ||
      page === undefined
    ) {
      return null;
    }
    const from = page * itemsPerPage + 1;
    let to = (page + 1) * itemsPerPage;
    if (to > totalCount) {
      to = totalCount;
    }
    return `${from}-${to} of ${totalCount}`;
  }, [itemsPerPage, page, totalCount]);

  const labelDisplayedRowsResult = React.useMemo(() => {
    if (!mdUp) {
      return "results";
    }
    if (
      !labelDisplayedRows ||
      totalCount === undefined ||
      !itemsPerPage ||
      page === undefined
    ) {
      return "results";
    }
    const from = page * itemsPerPage + 1;
    let to = (page + 1) * itemsPerPage;
    if (to > totalCount) {
      to = totalCount;
    }
    return labelDisplayedRows({
      from,
      to,
      page,
      count: totalCount,
    });
  }, [itemsPerPage, labelDisplayedRows, mdUp, page, totalCount]);

  if (!totalCount) {
    return null;
  }

  const count = Math.ceil(totalCount / itemsPerPage);

  const options = itemsPerPageOptions.map((nu) => ({
    label: String(nu),
    value: nu,
  }));

  return (
    <Box {...other} className={classes.root}>
      <div className={classes.select}>
        <SelectField
          options={options}
          onChangeValue={onItemsPerPageChange}
          value={itemsPerPage}
        />
      </div>
      <div className={classes.result}>
        <Typography variant="body2" color="grey" tone={700}>
          {labelDisplayedRowsResult}
        </Typography>
      </div>
      <div className={classes.text}>
        <Typography variant="body2" color="grey" tone={700}>
          {text}
        </Typography>
      </div>
      <div className={classes.pagination}>
        <Pagination
          count={count}
          page={page + 1}
          siblingCount={0}
          boundaryCount={1}
          onChange={handlePageChange}
          hidePageButtons={!mdUp}
        />
      </div>
    </Box>
  );
}

export default Paginator;
